// extracted by mini-css-extract-plugin
export var container = "file-preview-module--container--a4978";
export var disabled = "file-preview-module--disabled--b9313";
export var image = "file-preview-module--image--9e32e";
export var link = "file-preview-module--link--118cb";
export var m = "file-preview-module--m--fb18c";
export var preview = "file-preview-module--preview--babc7";
export var s = "file-preview-module--s--05a85";